module.exports = __webpack_public_path__ + "static/img/7.a1d9e22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/7.jpg
// module id = M1a8
// module chunks = 1